import React from 'react';
import HomeSection3 from '../../HomeSection3';
import HomeSection from '../../HomeSection';
import {
    sectionThreeObj,
    sectionTwoObj, 
} from './Data';



const Products = () => {
    return (
        <div>
            <HomeSection3 {...sectionThreeObj}/>
            <HomeSection {...sectionTwoObj}/>         
        </div>
    )
}

export default Products;
